import React, { createContext, useContext, useState } from "react";

export const CoursesContext = createContext();

const CoursesProvider = ({ children }) => {
  const saveCourse = (mandatory) => {
    sessionStorage.setItem("courseData", JSON.stringify(mandatory));
  };
  const getCourse = () => {
    const data = sessionStorage.getItem("courseData");
    return data ? JSON.parse(data) : null;
  };

  const [courseData, setCourseData] = useState(getCourse());

  return (
    <CoursesContext.Provider
      value={{
        courseData,
        setCourseData,
        saveCourse,
        getCourse,
      }}
    >
      {children}
    </CoursesContext.Provider>
  );
};

const useCoursesContext = () => {
  const context = useContext(CoursesContext);
  if (!context) {
    throw new Error(
      "useCoursesContext must be used inside a CoursesProvider"
    );
  }
  return context;
};

export { CoursesProvider, useCoursesContext };
